
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Box from 'vux/src/components/box/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default{
data () {
return {
amount: 0,
list: [
{ label: '交易号', value: 'TX-1234566777777' },
{ label: '卡号', value: '1234566777777' },
{ label: '收款人', value: '陈一二' }
],
file: null,
preview: null,
defaultPreview: 0
}
},
mounted () {
const { transId } = this.$router.currentRoute.query
this.$models.Deposit.c2c({
trans_id: transId
}).then(response => {
const { success, data } = response.data
if (success) {
this.amount = data.amount
this.list = [
{ label: '交易号', value: transId || 'undefined' },
{ label: '卡号', value: data.card_number },
{ label: '收款人', value: data.owner }
]
this.deadline = data.trans_expire_datetime
} else {

}
})
},
components: {
CellFormPreview,
XHeader,
Box,
ViewBox,
Cell,
Group,
XButton
},
methods: {
previewImage () {
if (this.preview !== null) {
this.defaultPreview = 1
return this.preview
}
},
uploadImage () {
const file = document.querySelector('input[type=file]').files[0]
if (file['type'] === 'image/jpeg' || file['type'] === 'image/png') {
const reader = new FileReader()
let rawImg
reader.onloadend = () => {
rawImg = reader.result
if (rawImg) {
this.$emit('load', rawImg)
this.preview = rawImg
}
}
reader.readAsDataURL(file)
console.log(file)
} else {
this.defaultPreview = 0
this.preview = ''
return this.preview
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/C2C.vue